export function HeadController(restaurantService) {
    'ngInject';
    const ctrl = this;
    ctrl.data = restaurantService.data;
}
